// extracted by mini-css-extract-plugin
export default {"TableView":"SalesTable_TableView__wZtNl","Cell":"SalesTable_Cell__5m5Sj","Paper":"SalesTable_Paper__Q82JF"};